import React from 'react'
import { Body } from 'components/Shell/Shell'
import { DumbField } from 'components/Wizard2/Field'
import { TextInput } from 'components/Wizard2/fieldComponents/Form'
import FormCard from 'components/FormCard/FormCard'
import { VERIFY_CERTIFICATE } from 'requests'
import ShieldIcon from '@tecuity/sos-icons/react/shield'
import format from 'date-fns/format'
import './Certificate.scss'
import { RadioInput } from '../Wizard2/fieldComponents/Form'
import Markdown from 'components/Markdown/Markdown'

export default class VerifyCertificate extends React.Component {
  state = {
    certificateId: '',
    errors: {},
    certificate: null,
    certError: null,
    category: 'business',
  }
  setCertificateId = (certificateId) => {
    this.setState({ certificateId })
  }
  checkEnter = (e) => {
    if (e.charCode === 13) {
      this.validate()
    }
  }
  validate = () => {
    if (this.state.certificateId === '') {
      this.setState({
        errors: {
          certificateId:
            process.env.CERTIFICATE_VERIFICATION_ERROR || 'A certificate ID is required',
        },
      })
    } else {
      this.setState({ errors: { certificateId: '' } })
      this.verifyCertificate(this.state.certificateId)
    }
  }
  verifyCertificate = (certificateId) => {
    this.setState({ certError: null })
    VERIFY_CERTIFICATE(
      certificateId,
      process.env.COMBINED_CERTIFICATE_VERIFICATION ? this.state.category : '',
      (certificate) => {
        this.setState({ certificate })
      },
      (err) => {
        if (err.code === 'certification/certificateNotValid') {
          this.setState({ certError: err.message, certificate: null })
        }
      }
    )
  }
  render() {
    return (
      <Body className="flex-center-page">
        <FormCard
          seal
          title={process.env.CERTIFICATE_VERIFICATION_TITLE || 'Verify Certificate'}
          leftColumn={
            <React.Fragment>
              <DumbField
                label={process.env.CERTIFICATE_VERIFICATION_LABEL || 'Certificate ID'}
                errorMessage={
                  this.state.errors.certificateId ? [this.state.errors.certificateId] : []
                }
              >
                <TextInput
                  value={this.state.certificateId}
                  onChange={this.setCertificateId}
                  onKeyPress={this.checkEnter}
                />
              </DumbField>
              {process.env.COMBINED_CERTIFICATE_VERIFICATION ? (
                <DumbField label="Select a Certificate Type">
                  <RadioInput
                    value={this.state.category}
                    onChange={(value) => {
                      this.setState({ category: value })
                    }}
                    options={[
                      { value: 'business', label: 'Business' },
                      { value: 'ucc', label: 'UCC' },
                    ]}
                  />
                </DumbField>
              ) : null}
              <button className="btn btn-primary btn-raised" onClick={this.validate}>
                Verify Certificate
              </button>
            </React.Fragment>
          }
          rightColumn={
            <React.Fragment>
              {this.state.certificate ? null : (
                <p className="description">
                  {process.env.CERTIFICATE_VERIFICATION_DESCR ||
                    'To verify a certificate, input the certificate ID found in the bottom left corner of your certificate.'}
                </p>
              )}
              {this.state.certError && (
                <p className="description danger-text">{this.state.certError}</p>
              )}
              {this.state.certificate && (
                <Certificate certificate={this.state.certificate} searchRoute={this.searchRoute} />
              )}
            </React.Fragment>
          }
        />
      </Body>
    )
  }
}

const Certificate = ({
  certificate: {
    CERTIFICATION_TYPE_DESCR,
    COPIES_FILING_DESCR,
    FILING_NUM,
    FILING_DATE,
    DISPLAY_TYPE,
    DETAIL_LIST = [],
    COMMENT,
  },
}) => (
  <div className="certificate-success">
    <p className="description message">
      <ShieldIcon /> This certificate has been verified.
    </p>
    {DISPLAY_TYPE === 'DETAIL_LIST' ? (
      <div>
        <table className="verify-certificate-table">
          <tbody>
            {DETAIL_LIST.map((detail, i) => (
              <tr key={i}>
                <td className="label">
                  <strong>{detail.label}:</strong>
                </td>
                <td className="value">{detail.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <br />
        {COMMENT && <Markdown className="description" source={COMMENT} />}
      </div>
    ) : (
      <React.Fragment>
        <span className="num">{FILING_NUM} - </span>
        <span className="date">{format(new Date(FILING_DATE), 'MM/dd/yyyy')}</span>
        <p>{CERTIFICATION_TYPE_DESCR}</p>
        <p>{COPIES_FILING_DESCR}</p>
      </React.Fragment>
    )}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Certificates/VerifyCertificate.js